import type { IPage } from "@/types";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { THubspotIntegration } from "./types";

const initialState: THubspotIntegration = {
  view: "main",
  story: null,
  folderId: null,
  hubspotParams: {},
  contact: null,
};

export const hubspotIntegrationSlice = createSlice({
  name: "hubspot-integration",
  initialState,
  reducers: {
    setView: (state: THubspotIntegration, action: PayloadAction<string>) => {
      state.view = action.payload;
    },
    setStory: (
      state: THubspotIntegration,
      action: PayloadAction<{ story: IPage | null; view: string }>,
    ) => {
      const { story, view } = action.payload;
      state.story = story;
      state.view = view;
    },
    setFolderId: (
      state: THubspotIntegration,
      action: PayloadAction<string | null>,
    ) => {
      state.folderId = action.payload;
    },
    setHubspotParams: (
      state: THubspotIntegration,
      action: PayloadAction<Record<string, string>>,
    ) => {
      state.hubspotParams = action.payload;
    },
    setContact(
      state: THubspotIntegration,
      action: PayloadAction<Record<string, unknown>>,
    ) {
      state.contact = action.payload;
    },
  },
});

export const { setView, setStory, setFolderId, setHubspotParams, setContact } =
  hubspotIntegrationSlice.actions;
